export default __webpack_public_path__ + "i18n/sv.db0116fa4ed63c27501636d527ebb2c1.json";